import { useCallback, useEffect } from "react";
import {
  fetchCurrentKintoneEnvironment,
  type KintoneEnvironmentCurrent,
} from "@/api/kintone-environment";
import { useConsoleReadState } from "@/contexts/ConsoleReadState";

export function useKintoneEnvironment() {
  const state = useConsoleReadState();
  const { value: environment, loading: isLoading, error } = state.resource<KintoneEnvironmentCurrent>("environment");

  const refresh = useCallback(async () => {
    return state.readResource("environment", fetchCurrentKintoneEnvironment);
  }, [state]);

  useEffect(() => {
    void refresh();
  }, [refresh]);

  return { environment, isLoading, error, refresh };
}
